// removed by extract-text-webpack-plugin
module.exports = {"chart":"chart__1ZzqC"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Gateway/coms/GatewayDetail/coms/GatewaySFTrend/styles.scss
// module id = 2269
// module chunks = 1